import React from 'react';
import { pageContext } from 'ctm-util-functions';
import PropTypes from 'prop-types';
import { PrefillQuoteCTAButtons } from 'ctm-components/components/anon_prefill/prefill_quote_cta_buttons';
import { useStyles } from './prefill_styles';

export const PrefillWelcomeBackSplash = ({ proceedToVerify, startNewQuote }) => {
    const vertical = pageContext.getVertical();
    const classes = useStyles({ vertical });

    return (
        <div className={classes.splashWrapper}>
            <div className={classes.splashHeaderWrapper}>
                <h2 className={classes.splashHeader}>Welcome back!</h2>
                <p>We've saved your progress to help make things&nbsp;easier</p>
            </div>
            <PrefillQuoteCTAButtons continueDisabled={false} startNewQuote={startNewQuote} resumeQuoteFunc={proceedToVerify} showNewQuoteButton />
        </div>
    );
};

PrefillWelcomeBackSplash.propTypes = {
    proceedToVerify: PropTypes.func,
    startNewQuote: PropTypes.func
};
